/*
 * Themporium gift finder.
 * Three questions, then product cards fetched from a tag-filtered collection URL through
 * Shopify's Section Rendering API. If nothing matches exactly, the search is widened one
 * answer at a time and the shopper is told so.
 */
(function () {
  'use strict';

  var finder = document.querySelector('[data-gift-finder]');
  if (!finder) return;

  var steps = Array.prototype.slice.call(finder.querySelectorAll('[data-gf-step]'));
  var dots = Array.prototype.slice.call(finder.querySelectorAll('[data-gf-dot]'));
  var backBtn = finder.querySelector('[data-gf-back]');
  var restartBtn = finder.querySelector('[data-gf-restart]');
  var resultsBox = finder.querySelector('[data-gf-results]');
  var summary = finder.querySelector('[data-gf-summary]');
  var note = finder.querySelector('[data-gf-note]');
  var empty = finder.querySelector('[data-gf-empty]');
  var collectionUrl = finder.getAttribute('data-collection-url');
  var RESULTS = 3;
  var current = 0;
  var answers = {};

  function show(index, moveFocus) {
    current = index;
    steps.forEach(function (step, i) { step.hidden = i !== index; });
    dots.forEach(function (dot, i) {
      dot.classList.toggle('is-done', i < index);
      dot.classList.toggle('is-current', i === index);
    });
    backBtn.hidden = index === 0;
    restartBtn.hidden = index !== RESULTS;
    if (moveFocus) {
      var heading = steps[index].querySelector('h2');
      if (heading) heading.focus({ preventScroll: true });
      finder.scrollIntoView({ block: 'start', behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    }
  }

  function fetchCards(tags) {
    var path = collectionUrl + (tags.length ? '/' + tags.join('+') : '');
    return fetch(path + '?section_id=themporium-finder-results', { headers: { Accept: 'text/html' } })
      .then(function (res) { return res.ok ? res.text() : ''; })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        return Array.prototype.slice.call(doc.querySelectorAll('.tp-finder-result'));
      })
      .catch(function () { return []; });
  }

  function withinBudget(cards) {
    var min = answers.budget ? answers.budget.min : 0;
    var max = answers.budget ? answers.budget.max : 0;
    return cards.filter(function (card) {
      var price = parseInt(card.getAttribute('data-price'), 10) || 0;
      return price >= min && (max === 0 || price <= max);
    });
  }

  // Exact match first, then drop the interest, then drop the budget, then show anything for that person
  function search() {
    var who = answers.who && answers.who.tag ? [answers.who.tag] : [];
    var love = answers.love && answers.love.tag ? [answers.love.tag] : [];
    var attempts = [
      { tags: who.concat(love), budget: true, note: '' },
      { tags: who, budget: true, note: 'Nothing matched every answer, so here are other gifts for the same person and budget.' },
      { tags: who.concat(love), budget: false, note: 'Nothing matched that budget, so here are the closest gifts at other prices.' },
      { tags: who, budget: false, note: 'Nothing matched every answer, so here are other gifts for the same person.' }
    ];
    var seen = {};
    attempts = attempts.filter(function (a) {
      var key = a.tags.join('+') + '|' + a.budget;
      if (seen[key]) return false;
      seen[key] = true;
      return true;
    });

    function attempt(i) {
      if (i >= attempts.length) return Promise.resolve({ cards: [], note: '' });
      return fetchCards(attempts[i].tags).then(function (cards) {
        var kept = attempts[i].budget ? withinBudget(cards) : cards;
        return kept.length ? { cards: kept, note: attempts[i].note } : attempt(i + 1);
      });
    }
    return attempt(0);
  }

  function showResults() {
    var parts = ['who', 'love', 'budget'].map(function (key) { return answers[key] ? answers[key].label : ''; }).filter(Boolean);
    summary.textContent = parts.join(' · ');
    resultsBox.innerHTML = '';
    note.hidden = true;
    empty.hidden = true;
    resultsBox.setAttribute('aria-busy', 'true');
    finder.classList.add('is-searching');
    show(RESULTS, true);

    search().then(function (found) {
      finder.classList.remove('is-searching');
      resultsBox.removeAttribute('aria-busy');
      if (!found.cards.length) { empty.hidden = false; return; }
      if (found.note) { note.textContent = found.note; note.hidden = false; }
      var list = document.createElement('ul');
      list.className = 'tp-finder-results-list';
      found.cards.slice(0, 12).forEach(function (card) { list.appendChild(document.importNode(card, true)); });
      resultsBox.appendChild(list);
      // Let the magic layer repaint wish stars on the new cards
      document.dispatchEvent(new CustomEvent('shopify:section:load'));
    });
  }

  finder.addEventListener('click', function (e) {
    var option = e.target.closest('[data-gf-choice]');
    if (!option) return;
    var key = option.getAttribute('data-gf-choice');
    answers[key] = {
      label: option.textContent.trim().replace(/\s+/g, ' '),
      tag: option.getAttribute('data-tag') || '',
      min: parseInt(option.getAttribute('data-min'), 10) || 0,
      max: parseInt(option.getAttribute('data-max'), 10) || 0
    };
    Array.prototype.forEach.call(option.parentNode.children, function (sibling) {
      sibling.setAttribute('aria-pressed', String(sibling === option));
    });
    if (current + 1 >= RESULTS) showResults();
    else show(current + 1, true);
  });

  backBtn.addEventListener('click', function () { if (current > 0) show(current - 1, true); });
  restartBtn.addEventListener('click', function () {
    answers = {};
    Array.prototype.forEach.call(finder.querySelectorAll('[data-gf-choice]'), function (b) { b.removeAttribute('aria-pressed'); });
    show(0, true);
  });

  show(0, false);
})();
